




































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwBarProgress } from '@libs-uuif/shared/sw-progress';
import { MswWidgetCard } from '@/shared/custom-component/msw-widget-card';
import { MswUserGroupTabRoute } from '@/modules/msw-products/components/msw-user-group';
import  { MswApiService } from '@/shared/msw-api-service';
const cssPrefix = 'msw-usermgmt-widget';

@Component({
  components: {
    MswWidgetCard,
    SwBarProgress,
    SwIcon,
  },
})
export default class MswUsermgmtWidget extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  numberOfuserGroups = 0;
  numberOfusers = 0;
  waitForResp = false;

  routeToUser() {
    window.parent.postMessage({
      redirectUrl : `/m/feature/${MswUserGroupTabRoute.path}`,
    },                        '*');
    this.$router.push({ path: `/m/feature/${MswUserGroupTabRoute.path}` });
  }
  created() {
    this.waitForResp = true;
    MswApiService.widgetsInfo.getUserMgmt()
      .then((resp:any) => {
        this.waitForResp = false;
        if (resp['content'] && resp['msgDesc'] === 'Success') {
          this.numberOfusers = resp['content']['usersCount'] ? resp['content']['usersCount'] : 0;
          this.numberOfuserGroups = resp['content']['userGroupsCount'] ? resp['content']['userGroupsCount'] : 0;
        }
        if (resp['msgDesc'] !== 'Success') {
          throw new Error(resp['msgDesc']);
        }
      })
      .catch((err:any) => {
        this.waitForResp = false;
        console.warn(`Error:${err}`);
      });
  }
}
